import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { isPVQForm } from 'helpers/form';
import { PackageCommentsModel } from './types';

const packageCommentsValidator: ValidateJSModel<PackageCommentsModel> = {
  HasComments: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {}; // No additional Comments on PVQ
    }
    return { presence: true, hasValue: { validator: hasYesOrNo } };
  },
  Comments: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {}; // No additional Comments on PVQ
    }
    if (attributes?.HasComments?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
};

export default packageCommentsValidator;
